import Toast from '@components/toast';

// Evento do Chrome e do Edge; o navegador só aceita abrir o prompt em resposta a um clique.
interface EventoInstalacao extends Event {
    prompt(): Promise<void>;
    userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let eventoInstalacao: EventoInstalacao | null = null;

export function registrarServiceWorker(): void {
    if (!('serviceWorker' in navigator)) return;

    // Falhar aqui não pode travar o app: o service worker só serve para instalar e para o aviso offline.
    const registrar = () => navigator.serviceWorker.register('/sw.js', { scope: '/' })
        .catch(erro => console.warn('[BeachBike] service worker não registrado:', erro));

    if (document.readyState === 'complete') registrar();
    else window.addEventListener('load', registrar);
}

export function initInstalacao(): void {
    if (emModoApp()) return;

    window.addEventListener('beforeinstallprompt', evento => {
        // Sem isto o Chrome mostra a própria barra de instalação.
        evento.preventDefault();
        eventoInstalacao = evento as EventoInstalacao;
        mostrarBotoes(true);
    });

    window.addEventListener('appinstalled', () => {
        eventoInstalacao = null;
        mostrarBotoes(false);
        Toast.success('BeachBike instalado neste aparelho.');
    });

    quandoPronto(() => {
        const ios = ehIos();
        document.querySelectorAll<HTMLElement>('[data-instalar-app]').forEach(el => {
            el.addEventListener('click', () => {
                fecharDropdown(el);
                if (ios) abrirInstrucoesIos();
                else instalar();
            });
        });
        // No iOS não há evento para esperar: o botão aparece e explica o caminho pelo Compartilhar.
        if (ios || eventoInstalacao) mostrarBotoes(true);
    });
}

async function instalar(): Promise<void> {
    if (!eventoInstalacao) return;

    // O evento é de uso único: recusado, o botão volta só quando o navegador disparar outro.
    const evento = eventoInstalacao;
    eventoInstalacao = null;
    mostrarBotoes(false);

    try {
        await evento.prompt();
        await evento.userChoice;
    } catch {
        // Prompt negado pelo navegador: nada a fazer.
    }
}

function emModoApp(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches
        || window.matchMedia('(display-mode: minimal-ui)').matches
        || (navigator as any).standalone === true;
}

function ehIos(): boolean {
    const ua = navigator.userAgent;
    // iPadOS se apresenta como Mac; o toque é o que denuncia.
    return /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}

function mostrarBotoes(visivel: boolean): void {
    document.querySelectorAll<HTMLElement>('[data-instalar-app]').forEach(el => { el.hidden = !visivel; });
}

function abrirInstrucoesIos(): void {
    const modal = document.getElementById('modalInstalarIos');
    if (modal) (window as any).bootstrap?.Modal.getOrCreateInstance(modal).show();
}

function fecharDropdown(el: HTMLElement): void {
    const toggle = el.closest('.dropdown')?.querySelector('[data-bs-toggle="dropdown"]');
    if (toggle) (window as any).bootstrap?.Dropdown.getInstance(toggle)?.hide();
}

function quandoPronto(acao: () => void): void {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', acao);
    else acao();
}
